<script setup>
const tours = useTourStore();
const wishlistStore = useWishlistStore();

const wishlist = wishlistStore.wishlist;

const route = useRoute();
const tourTypeSlug = route.params.tourTypeSlug;

const filteredTours = computed(() => {
  if (!tourTypeSlug) {
    return tours.getTours;
  }

  // check if tourTypeSlug is wishlist
  if (tourTypeSlug === "wishlist") {
    return tours.getTours.filter((tour) => wishlist.includes(tour.slug));
  }

  return tours.getTours.filter((tour) =>
    tour.activity_type.some((type) => type.slug === tourTypeSlug),
  );
});

// Swiper
import { register } from "swiper/element/bundle";
import { Autoplay } from "swiper/modules";

register();
// end swiper
</script>
<template>
  <div class="mb-0 mt-4">
    <div v-if="tourTypeSlug === 'wishlist' && wishlist.length === 0">
      <p class="my-6 text-center font-semibold text-[#535353]">
        You don't have wishlist yet.
      </p>
    </div>

    <swiper-container
      v-if="filteredTours.length > 0"
      class="mySwiper"
      :spaceBetween="10"
      :slidesPerView="1"
      :breakpoints="{
        768: {
          slidesPerView: 3,
        },
      }"
      :pagination="true"
      :loop="true"
      :autoplay="{
        delay: 4000,
        disableOnInteraction: false,
      }"
    >
      <swiper-slide v-for="tour in filteredTours" :key="tour.id">
        <FeatureSliderItem :tour="tour" />
      </swiper-slide>
    </swiper-container>
  </div>
</template>

<style scoped>
swiper-container::part(pagination) {
  position: relative;
  margin-top: 30px;
}

swiper-container::part(bullet) {
  background: #0085ff;
}

swiper-container::part(bullet-active) {
  background: #0085ff;
}
</style>
